/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './header'
import UserMenu from './userMenu'
import Toast from './sub_components/toast'
import Currency from './sub_components/currency'
import * as accountStatementService from '../services/accountStatementService'
import * as casinoReportsService from '../services/casinoReportsService'
import * as dateUtil from '../util/date.util'
import { CSVLink } from 'react-csv';
import printJS from 'print-js'
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { staticContentsImagePath as BASE_IMAGE_PATH } from '../configs/const';
import * as _ from 'lodash'
import SinglePageUnderMaintenance from './singlePageUnderMaintenance';
import * as authUtil from "../util/auth.util";
import { getEventsListForResult, getResultByEventID } from '../services/eventService';
import moment from 'moment';

class Result extends Component {
    csvLink = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            user_id: '',
            types: "ALL",
            statements_data: [],
            orders: [],
            statements_search_data: [],
            csv_json: [],
            pdf_json: [],
            competition_id: "",
            event_id: "",
            market_id: "",
            last_id: "",
            first_id: "",
            action: "",
            from: "",
            to: "",
            page_no: 1,
            count_records: 0,
            records_per_page: 25,
            opening_balance: 0,
            closing_balance: 0,
            current_balance: 0,
            hst_balance: "",
            hst_id: "",
            showToast: false,
            showPopup: false,
            showPopuploader: false,
            toastMsg: "",
            toastType: "",
            showData: false,
            loader: false,
            isMaintanance: false,
            eventType: 4,
            resultEventList: {},
            today: '',
            yesterday: '',
            filterDate: '',
            selectedEventId: '',
            resultList: [],
            dispTitle: ''
        };
    }

    componentDidMount() {
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if (!(!!userData && !!userData.sub)) {
            authUtil.logout(true);
        }
        // let today = moment().format('YYYY-MM-DD');
        // let yesterday = moment(new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)).format('YYYY-MM-DD');
        // this.setState({ user_id: userData.sub, to: curDate, from: weekDate })
        this.setState({
            today: 'today',
            yesterday: 'yesterday',
            filterDate: 'today'
        })
        this.submitForm()
    }

    parseToPickerDate(date) {
        let dtArr = date.split("/")
        let dt = dtArr[2] + "-" + (dtArr[0].split("").length === 2 ? dtArr[0] : "0" + dtArr[0]) + "-" + (dtArr[1].split("").length === 2 ? dtArr[1] : "0" + dtArr[1])
        return dt
    }

    async submitForm() {
        const self = this;
        this.setState({ loader: true, resultEventList: {}, showData: false })
        await getEventsListForResult(this.state.eventType).then((res) => {
            if (res.isSuccess) {
                self.setState(
                    {
                        resultEventList: {},
                        showData: true,
                    }, () => {
                        // let closing_bal = res.openingBalance;
                        // let evtdt = {}
                        // for (let smt of res.items) {
                        //     const keydate = smt.openDate.split[0];
                        //     if (!(!!evtdt[keydate])) {
                        //         evtdt[keydate] = [];
                        //     }
                        //     evtdt[keydate].push(smt);
                        // };
                        self.setState({
                            resultEventList: res,
                            loader: false
                        })
                    }
                );
            } else {
                this.setState({ resultEventList: {}, showData: true, loader: false })
            }
        })
    }
    async onDownload() {
        const self = this;
        this.setState({ csv_json: [] }, () => {

            let trans = this.state.statements_search_data
            let dictinory = {}
            let balance = this.state.opening_balance
            let items = []
            let filter_user_id = this.state.user_id
            dictinory["Date"] = ""
            dictinory["Credit"] = ""
            dictinory["Debit"] = ""
            dictinory["Balance"] = Math.round((balance + Number.EPSILON) * 100) / 100
            dictinory["Description"] = "Opening Balance"
            items.push(dictinory)
            for (let x of trans) {
                dictinory = {}
                let st = x["createdAt"].split(" ")
                let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                let dt = new Date(dtstr).toLocaleString("en-IN")
                dictinory["Date"] = dt
                if (x["creditAccount"] === filter_user_id) {
                    dictinory["Credit"] = x["amount"]
                    dictinory["Debit"] = "-"
                    balance -= Math.round((x["amount"] + Number.EPSILON) * 100) / 100
                }
                if (x["debitAccount"] === filter_user_id) {
                    dictinory["Credit"] = "-"
                    dictinory["Debit"] = x["amount"]
                    balance += Math.round((x["amount"] + Number.EPSILON) * 100) / 100
                }
                dictinory["Balance"] = Math.round((balance + Number.EPSILON) * 100) / 100
                dictinory["Description"] = x["description"]

                items.push(dictinory)

            }
            this.setState({ csv_json: items }, () => {
                setTimeout(function () {
                    self.csvLink.current.link.click();
                }, 500)

            })
        })
    }
    async onPDFDownload() {
        this.setState({ pdf_json: [] }, () => {
            this.setState({ pdf_json: this.state.statements_search_data }, () => {
                setTimeout(function () {
                    printJS({
                        printable: 'printJS-div',
                        type: 'html',
                        targetStyles: ['*']
                    })
                }, 500)
            })
        })
    }
    async marketOrders() {
        const self = this;
        // let body = {
        //     "filters": {
        //         "amount_from": 0,
        //         "amount_to": 0,
        //         "event_type_category": "",
        //         "competition_id": "",
        //         "event_id": "",
        //         "market_id": this.state.market_id,
        //         "market_type": "",
        //         "betstatus": [""]
        //     },
        //     "user_id": this.state.user_id,
        //     "last_id": "",
        //     "first_id": "",
        //     "action": "",
        //     "from": "",
        //     "to": "",
        //     "records_per_page": 100,
        //     "page_no": 1,
        //     "count_records": 0
        // }

        let body = {
            "filters": {
                "betStatus": "",
                "eventTypeCategory": "",
                "marketId": this.state.market_id,
            },
            "firstId": "",
            "lastId": "",
            "action": "",
            "from": "",
            "to": "",
            "pageNo": 1,
            "recordsPerPage": 100,
            "countRecords": this.state.count_records,
        }

        body = this.clean(body);
        this.setState({ orders: [], showPopuploader: true })
        await casinoReportsService.postOrders(body).then((res) => {
            if (res.isSuccess) {
                let orders = res.items.filter((bet) => { return bet.eventTypeId !== "99" || (bet.eventTypeId === "99" && bet.betStatus !== "VOID") })
                self.setState(
                    {
                        orders: orders,
                        competition_id: "",
                        event_id: "",
                        market_id: "",
                        showPopuploader: false
                    }
                );
            }
            else {
                this.setState({ orders: [], showPopuploader: false })
            }
        })
    }
    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }
    hidePopup() {
        this.setState({ showPopup: false, selectedEventId: '', dispTitle: '', showPopuploader: false, resultList: [] })
    }

    showPopup(type, id) {
        const name = type;
        let value = id;
        this.setState({ [name]: value, showPopup: true }, () => { this.marketOrders() })
    }
    onAction(e) {
        const value = e.target.name;
        let page_n = 1;
        if (value === "next") {
            page_n = this.state.page_no + 1;
        }
        if (value === "prev") {
            page_n = this.state.page_no - 1;
        }
        this.setState({ action: value, page_no: page_n }, () => { this.submitForm(); });
    }
    resetForm() {
        let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0);
        let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        this.setState({ types: "ALL", showData: false, records_per_page: 25, from: weekDate, to: curDate, statements_data: [], statements_search_data: [], last_id: "", first_id: "", action: "", page_no: 1, count_records: 0, hst_balance: 0, hst_id: "", current_balance: 0, opening_balance: 0, closing_balance: 0 })
    }
    onSubmit(e) {
        let diffTime = Math.abs(new Date(this.state.to) - new Date(this.state.from))
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays > 31) {
            this.props.notify("Date range must be 1 month.", "error")
        }
        else {
            this.setState({ action: "", page_no: 1, hst_balance: 0, hst_id: "", current_balance: 0 }, () => { this.submitForm(); });
        }
    }
    onChange(e) {
        const name = e.target.name;
        let value = e.target.value;
        if (name === "eventType") {
            this.setState({ [name]: value }, () => { this.submitForm() });
        }
        else {
            this.setState({ [name]: value });
        }
    }
    setFilerType(fil) {
        this.setState({ filterDate: fil })
    }
    setMarketForm(type, id) {
        let body = {
            type: type,
            id: id
        }
        localStorage.setItem("casinoReportFilter", JSON.stringify(body))
        this.props.history.push("/orders");
    }
    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }
    updateMaintanence(status) {
        this.setState({ isMaintanance: status })
    }
    onDateTimeChange(name, e) {
        this.setState({ [name]: e._d })
    }
    onSearch(e) {
        const value = e.target.value;
        if (this.state.statements_search_data) {
            let statements_lst = _.filter(this.state.statements_search_data, function (obj) {
                return JSON.stringify(obj).toLowerCase().indexOf(value.toLowerCase()) !== -1;
            });
            this.setState({ statements_data: [] }, () => {
                this.setState({ statements_data: statements_lst });
            })

        }
    }

    onEventClick(evtid, dispTitle) {
        const self = this;
        this.setState({ showPopup: true, selectedEventId: evtid, dispTitle: dispTitle, showPopuploader: true }, () => {
            getResultByEventID(this.state.selectedEventId).then((res) => {
                if (res.isSuccess) {
                    self.setState(
                        {
                            resultList: [],
                            showPopuploader: false,
                        }, () => {
                            self.setState({
                                resultList: res.items,
                                showPopuploader: false
                            })
                        }
                    );
                } else {
                    this.setState({ resultList: [], showPopuploader: false })
                }
            })
        })
    }
    render() {
        return (
            <div className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} updateMaintanence={(status) => { this.updateMaintanence(status) }} />
                <div className="full-wrap footerpd">
                    <UserMenu history={this.props.history} isMaintanance={this.state.isMaintanance} />
                    <div className="col-center1 markets">
                        <div className="mar-top100">
                            <div className="sub_path center-box mt-2">
                                <p>Results</p>
                            </div>

                            <div className="allreport col3">
                                <div className="row mx-0 results-box">



                                    <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2 mb-0 mt-2">
                                        <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                            <button className="btn place-bet-btn" onClick={() => this.setFilerType(this.state.today)}>Today</button>
                                            <button className="btn place-bet-btn ml-1" onClick={() => this.setFilerType(this.state.yesterday)}>Yesterday</button>
                                        </div>
                                    </div>
                                    <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2 mb-0 mt-2'>
                                        <div className="form-group font-12 float-right mb-0">
                                            <select className="form-control" name="eventType" value={this.state.eventType} onChange={(e) => this.onChange(e)}>
                                                <option value={4}>Cricket</option>
                                                <option value={1}>Soccer</option>
                                                <option value={2}>Tennis</option>
                                                <option value={7}>Horse</option>
                                                <option value={4339}>Greyhound</option>
                                                <option value={400}>Kabaddi</option>
                                                <option value={500}>Election</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>
                                {!this.state.showData && !!this.state.loader ?
                                    <div className={"ml-2"}>Loading......</div>
                                    :
                                    <div>

                                        <div className="dt-responsive table-responsive account-statment p-2">
                                            <table id="basic-btn" className="table table-bordered nowrap table-sm mb-1 addpadding">
                                                <thead>
                                                    <tr className="bg-dark text-white">
                                                        <th className="wid140 pthead">Date</th>
                                                        <th className=" pthead">Event Name</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        !!this.state.resultEventList &&
                                                            !!this.state.resultEventList[`${this.state.filterDate}_result`] &&
                                                            this.state.resultEventList[`${this.state.filterDate}_result`].length > 0 ?
                                                            this.state.resultEventList[`${this.state.filterDate}_result`].map((item, index) => {
                                                                return (
                                                                    <tr key={`${item.event_id}_${index}`} onClick={() => this.onEventClick(item.event_id, `${item.competition_name}-${item.event_name} [${moment(item.open_date).format('DD/MM/YYYY HH:mm')}]`)}>
                                                                        <td className="text-left" > {moment(item.declared_date).format('DD/MM/YYYY HH:mm')}</td>
                                                                        <td className="text-left cursor undline" title={`${item.competition_name}-${item.event_name} [${moment(item.open_date).format('DD/MM/YYYY HH:mm')}]`}>{item.competition_name}-{item.event_name} [{moment(item.open_date).format('DD/MM/YYYY HH:mm')}]</td>
                                                                    </tr>
                                                                )
                                                            })
                                                            :
                                                            <tr>
                                                                <td colSpan={2}>no data found.....</td>
                                                            </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                }

                                {/* maintainance code start */}
                                {/*
                                    <SinglePageUnderMaintenance pageOrReport={'This report'} maintananceDuration={'24 to 48 hours'}></SinglePageUnderMaintenance>
                                */}
                                {/* maintainance code end */}

                            </div>
                        </div>
                    </div>
                    {this.state.showPopup && <>
                        <div id="marketbetspopup" className="modal fade marketbetspopupresults show" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                            <div className="modal-dialog modal-md modal-dialog-scrollable">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title mt-0" id="myModalLabel">Results - {this.state.event_id} {this.state.dispTitle}</h5><button onClick={() => { this.hidePopup() }} type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="table-responsive">
                                            <table id="basic-btn" className="table  table-bordered font-12 table-sm">
                                                <thead>
                                                    <tr className="bg-dark text-white">
                                                        {/* <th className="pthead">Market ID</th> */}
                                                        <th className="pthead">Market</th>
                                                        <th className="pthead">Winner</th>
                                                        <th className="pthead">Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!!this.state.showPopuploader ?
                                                        <tr>
                                                            <td colSpan={4} className="text-center py-5">
                                                                <h5 className="text-dark font-weight-bold m-0"> Loading...... </h5>
                                                            </td>
                                                        </tr> :
                                                        this.state.resultList.length > 0 ? this.state.resultList.map((ordr, i) => {
                                                            let order = ordr;
                                                            let st = (order.createdAt).split(" ")
                                                            let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                                                            let dt = new Date(dtstr).toLocaleString("en-IN")
                                                            let pyld = !!order.payload ? JSON.parse(order.payload) : {}
                                                            return (
                                                                <tr key={i} bgcolor={order.side === 0 ? "#72BBEF" : order.side === 1 ? "#FAA9BA" : ""}>
                                                                    {/* <td>{order.marketId}</td> */}
                                                                    <td>{order.marketName ? order.marketName : ""}</td>
                                                                    <td>{pyld.marketResultSummary.bettingType !== "LINE" ? `${!!order.winnerName ? order.winnerName : ''}` : pyld.marketResultSummary.winnerId}</td>
                                                                    <td>{dt ? dt : "-"}</td>
                                                                </tr>
                                                            );
                                                        }) : <tr>
                                                            <td colSpan={4} className="text-center py-5"><h5 className="text-danger font-weight-bold m-0">No data found....</h5></td>
                                                        </tr>}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" onClick={() => { this.hidePopup() }} className="btn btn-outline-danger waves-effect mx-auto" data-dismiss="modal">Cancel</button>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-backdrop fade show" onClick={() => { this.hidePopup() }}></div>
                        </div>

                    </>}
                    {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                </div>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Result);